module.exports = __webpack_public_path__ + "img/garden_with_types_5.cc1e5b71.png";